import { Phone, MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { CONTACT } from "@/data/content";

export default function FloatingContact() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 2, duration: 0.8 }}
      className="fixed bottom-6 right-6 z-50 flex flex-col gap-3"
    >
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat on WhatsApp"
        className="w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_32px_rgba(0,0,0,0.5)] hover:scale-110 transition-transform duration-300"
      >
        <MessageCircle size={24} />
      </a>
      <a
        href={`tel:${CONTACT.phoneRaw}`}
        data-testid="floating-call-button"
        aria-label="Call us now"
        className="w-14 h-14 rounded-full bg-[#d4af37] text-[#0A1128] flex items-center justify-center shadow-[0_8px_32px_rgba(0,0,0,0.5)] hover:scale-110 transition-transform duration-300"
      >
        <Phone size={22} />
      </a>
    </motion.div>
  );
}
